import React from 'react';
import PropTypes from 'prop-types';

class MessageInput extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'MessageInput';
    this.state = {
    	body : ''
    }

    this.handleChange = this.handleChange.bind(this);
    this.focus = this.focus.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.checkForEnter = this.checkForEnter.bind(this);
  }

  checkForEnter(event) {
  	if (event.key === 'Enter') {
  		this.handleEnter();
  	}
	}

  handleChange(event) {
  	this.setState({body : event.target.value});
  }

  handleEnter(event) {
  	if(this.props.onEnter) {
    	this.props.onEnter(this.state.body);
  	}
    this.setState({body : ''});
  }

  focus() {
  	this.refs.input.focus();
  }

  render() {
    return 	(
    	<div className="input-group">
        <input 
        	ref="input" 
        	className="form-control" 
        	type='text' 
        	onChange={this.handleChange} 
        	onKeyPress={this.checkForEnter} 
        	value={this.state.body} />
				<span className="input-group-btn">
					<span 
						onClick={this.handleEnter}	
						className="btn btn-primary" 
						type="submit">
							Send
					</span>
				</span>   				
			</div>
		);
  }
}

export default MessageInput;



// WEBPACK FOOTER //
// ./src/browser/components/live_weather_center/chat/messageInput.js